<h2 style="max-width: 455px" mat-dialog-title>
	{{ data.titleKey | transloco }}
</h2>
<mat-dialog-content>
	@if (data.messageKey) {
		<p>{{ data.messageKey | transloco }}</p>
	}
	@if (data.contextLabel) {
		<p>
			<strong>{{ data.contextLabel }}</strong>
		</p>
	}
</mat-dialog-content>
<mat-dialog-actions class="actions-row">
	<lvr-button
		variant="secondary"
		[label]="data.cancelKey ?? 'base.button.cancel' | transloco"
		[type]="'button'"
		[mat-dialog-close]="false"
		[icon]="data.iconCancel ?? 'disabled_by_default'"
	></lvr-button>
	<lvr-button
		variant="primary"
		[label]="data.confirmKey ?? 'base.button.delete' | transloco"
		[type]="'button'"
		[mat-dialog-close]="true"
		[icon]="data.iconConfirm ?? 'delete' | transloco"
	></lvr-button>
</mat-dialog-actions>
